import { Injectable, OnInit } from "@angular/core";
import * as firebase from "firebase";
import "rxjs/add/operator/take";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Notification, isFromConversation } from "../../fiscalia/domain/notification";
import { Observable } from "rxjs/Observable";
import { Http, RequestMethod, Response } from "@angular/http";
import { environment } from "environments/environment";
import { AuthService } from "app/core/security/auth.service";
import { GenericService } from "app/core/commons/generic.service";
import { QueryOptions } from "app/core/commons/query.options";
import { Message } from "app/fiscalia/domain/message";
import { NotificationTopic } from "app/fiscalia/domain/notificationTopic";


@Injectable()
export class NotificationTopicService extends GenericService<NotificationTopic> {
  public getDefaultQueryOptions(): QueryOptions {
    return new QueryOptions();
  }

  protected valueToEntity(value: any): NotificationTopic | Observable<NotificationTopic> {
    return new NotificationTopic(value);
  }
  protected getResourcePath(): string {
    return "/notificationTopic";
  }

  constructor(authService: AuthService, private _http: Http) {
    super(authService);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/service/notificationTopic.service.ts